import diff from "deep-diff";

export function isValidNumber(v){
    return typeof v == 'number' && !isNaN(v);
}

export function objUpdate(old, updates) {
    const obj = deepCopy(old);//{...old};
    updates.forEach(change => diff.applyChange(obj, undefined, change));
    return obj;
}

/**
 * 
 * @param {Date} startDate 
 * @param {Date} endDate 
 */
export function splitDatesIntoIntervals(startDate, endDate){
    const days = Math.floor((endDate.getTime()-startDate.getTime())/(24*60*60*1000));
    const resolution = days <= 1 ? 'hour' : (days <= 60 ? 'day' : 'month');

    let intervals = [];
    let currentDate = new Date(startDate);
    
    while (currentDate < endDate){
        intervals.push(new Date(currentDate)); // punem new Date ca sa fie o copie, altfel se va pune mereu ultima data
        if (resolution == 'month') {
            // setam currentDate sa fie prima zi din urmatoarea luna, ora 00:00
            currentDate.setMonth(currentDate.getMonth()+1);
            currentDate.setDate(1);
            currentDate.setHours(0);
        }
        if (resolution == 'day') {
            // setam currentDate sa fie urmatoarea zi, ora 00:00
            currentDate.setDate(currentDate.getDate()+1);
            currentDate.setHours(0);
        }
        if (resolution == 'hour'){
            // setam currentDate sa fie urmatoarea ora
            currentDate.setHours(currentDate.getHours()+1);
        }
        // in toate cazurile, se considera minutul si secunda 0 (nu exista raport per minut)
        currentDate.setMinutes(0);
        currentDate.setSeconds(0,0);
    }

    return {resolution, intervals};
}

/**
 * @param {string} name 
 */
export function nameToURL(name){
    return encodeURIComponent(String(name??"")?.replace(/ /g, '_')) || "";
}

/**
 * @param {string} name 
 */
export function URLToName(str){
    return decodeURIComponent(String(str??"")).replace(/_/g, ' ');
}

export async function Wait(ms){
    return new Promise(resolve => setTimeout(resolve, ms));
}

export function preloadImage(url){
    const img = new Image();
    img.src = url;
}

export function isPrimitive(obj){
    return (obj !== Object(obj));
}

export function deepEqual(obj1, obj2) {
    if(obj1 === obj2) // it's just the same object. No need to compare.
        return true;

    if (typeof obj1 !== typeof obj2)
        return false;

    if (
        (obj1 === null && obj2 !== null) ||
        (obj1 !== null && obj2 === null) ||
        (obj1 === undefined && obj2 !== undefined) ||
        (obj1 !== undefined && obj2 === undefined)
    ) return false;

    if(isPrimitive(obj1) && isPrimitive(obj2)) // compare primitives
        return obj1 === obj2;

    if(Object.keys(obj1).length !== Object.keys(obj2).length)
        return false;

    // compare objects with same number of keys
    for(let key in obj1)
    {
        if(!(key in obj2)) return false; //other object doesn't have this prop
        if(!deepEqual(obj1[key], obj2[key])) return false;
    }

    return true;
}

export function deepCopy(obj) {
    if (obj == null || typeof obj !== "object") return obj;

    if (obj instanceof Date) {
        const newDate = new Date();
        newDate.setTime(obj.getTime());
        return newDate;
    }

    if (obj instanceof Array) {
        const copy = [];
        obj.forEach(el => copy.push(deepCopy(el)));
        return copy;
    }

    if (obj instanceof Object) {
        const copy = {};
        Object.keys(obj).forEach(key => {
            if (obj.hasOwnProperty(key)) copy[key] = deepCopy(obj[key]);
        });
        return copy;
    }

    throw new Error("Unable to copy obj! Its type isn't supported.");
}

/**
 * @param {string} str 
 */
export function capitalizeFirst(str){
    if (!str) return str;
    return str.charAt(0).toUpperCase() + str.slice(1);
}

/**
 * @param {Date} date
 */
export function simpleDateFormat(date){
    const YYYY = date.getFullYear(),
            MM = (date.getMonth()+1).toString().padStart(2, '0'),
            DD = date.getDate().toString().padStart(2, '0');
    return `${YYYY}-${MM}-${DD}`;
}